import { IColumn } from "OfficeFabric/DetailsList";
import WIT_Contracts = require("TFS/WorkItemTracking/Contracts");
import { Action } from "VSS/Flux/Action";

export interface IWorkItemColorsAndIcon {
    id: number;
    stateColor: string;
    icon: string;
    color: string;
}

export class LinkedItemsGridViewActionsHub {
    static readonly CHILD_SCOPE = "CHILD_SCOPE";
    
    public onError = new Action<string>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public onErrorMessageClose = new Action<void>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public workItemsLoaded = new Action<WIT_Contracts.WorkItem[]>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public colorsLoaded = new Action<IWorkItemColorsAndIcon[]>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public initializeSelection = new Action<void>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public initializeColumns = new Action<IColumn[]>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public dismissContextMenu = new Action<IColumn[]>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public updateContextMenuOpenIndex = new Action<number>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public afterSort = new Action<WIT_Contracts.WorkItem[]>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public afterWorkItemsDeleted = new Action<WIT_Contracts.WorkItem[]>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public clearState = new Action<void>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public updateWorkItem = new Action<WIT_Contracts.WorkItem>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
    public updateWorkItemColorsAndInfo = new Action<IWorkItemColorsAndIcon>(LinkedItemsGridViewActionsHub.CHILD_SCOPE);
}